import type { PropsWithChildren, ReactElement } from "react";
import { createContext, useState } from "react";
import { useBimTrackConfiguration } from "@ui/shared/hooks/useBimTrackConfiguration";
import Monitoring from "@core/shared/services/monitoring/Monitoring";
import type { NoProps } from "@shared/types/NoProps";

export const MonitoringContext = createContext<Monitoring | undefined>(undefined);

export const MonitoringProvider = ({ children }: PropsWithChildren<NoProps>): ReactElement => {
  const configurations = useBimTrackConfiguration();
  const [monitoringClient] = useState(new Monitoring(configurations.appInsightsConnectionString));

  return (
    <MonitoringContext.Provider value={monitoringClient}>
      {children}
    </MonitoringContext.Provider>
  );
};